// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicationVersionConflict } from "./PublicationVersionConflict";
import {
  PublicationVersionConflictFromJSON,
  PublicationVersionConflictFromJSONTyped,
  PublicationVersionConflictToJSON,
  PublicationVersionConflictToJSONTyped,
} from "./PublicationVersionConflict";

/**
 *
 * @export
 * @interface PublicationVersionConflictResponse
 */
export interface PublicationVersionConflictResponse {
  /**
   *
   */
  message: string;
  /**
   *
   */
  detail: PublicationVersionConflict;
}

/**
 * Check if a given object implements the PublicationVersionConflictResponse interface.
 */
export function instanceOfPublicationVersionConflictResponse(
  value: object
): value is PublicationVersionConflictResponse {
  if (!("message" in value) || value["message"] === undefined) return false;
  if (!("detail" in value) || value["detail"] === undefined) return false;
  return true;
}

export function PublicationVersionConflictResponseFromJSON(
  json: any
): PublicationVersionConflictResponse {
  return PublicationVersionConflictResponseFromJSONTyped(json, false);
}

export function PublicationVersionConflictResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionConflictResponse {
  if (json == null) {
    return json;
  }
  return {
    message: json["message"],
    detail: PublicationVersionConflictFromJSON(json["detail"]),
  };
}

export function PublicationVersionConflictResponseToJSON(
  json: any
): PublicationVersionConflictResponse {
  return PublicationVersionConflictResponseToJSONTyped(json, false);
}

export function PublicationVersionConflictResponseToJSONTyped(
  value?: PublicationVersionConflictResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    message: value["message"],
    detail: PublicationVersionConflictToJSON(value["detail"]),
  };
}
